import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import { NowPlayingContext } from './NowPlayingProvider';

const UpNextStrip = () => {
  const { playingNext, isLiveStream, isLive, isLoading, initialLoadComplete } = useContext(NowPlayingContext);

  if (!isLiveStream || isLive) return null;

  // isLoading also flips true on a station switch (toggleStreamUrl), even though playingNext
  // still holds the previous station's stale value - treat that the same as "waiting for data"
  // so the strip doesn't show the old station's up-next info while the new one loads.
  const showSkeleton = isLoading || (!playingNext && !initialLoadComplete);
  if (!playingNext && !showSkeleton) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        padding: 2,
        marginTop: 2,
        backgroundColor: 'rgba(255,255,255,0.05)',
        borderRadius: '0 0 4px 4px',
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 1,
          overflow: 'hidden',
          flexShrink: 0,
          boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
        }}
      >
        {showSkeleton ? (
          <Skeleton variant="rectangular" width={56} height={56} />
        ) : (
          <img
            src={playingNext.art || 'https://placehold.co/56'}
            alt={playingNext.title}
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        )}
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>
          Up Next
        </Typography>
        {showSkeleton ? (
          <>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={20} />
          </>
        ) : (
          <>
            <Typography
              variant="body1"
              sx={{ color: '#fff', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {playingNext.title}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: '#ccc', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {playingNext.artist}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default UpNextStrip;
